import * as requestFromServer from "./SystemUsersCrud";
import { systemUserSlice, callTypes } from "./SystemUsersSlice";

const {actions} = systemUserSlice;

export const getSystemUsers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getSystemUsers(queryParams)
    .then(response => {
      dispatch(actions.systemUsersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllSystemUsers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllSystemUsers(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getSystemUser = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  if (!id) {
    return requestFromServer
      .getNewSystemUser()
      .then(response => {
        dispatch(actions.systemUserFetched(response.data));
      })
      .catch(error => {
      
      });
  }

  return requestFromServer
    .getSystemUser(id)
    .then(response => {
      dispatch(actions.systemUserFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveSystemUser = systemUser => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveSystemUser(systemUser)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const deleteSystemUsers = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteSystemUsers(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanSystemUsersState = () => dispatch => {
  dispatch(actions.systemUsersStateCleaned());
}